import { Vue, Component, Prop } from 'vue-property-decorator'
import LinkItem from '~/types/LinkItem'
import ArrowSvg from '~/assets/svg/link-arrow.svg?inline'

@Component
export default class Breadcrumb extends Vue {
  @Prop({ type: Array, default: () => ([]) })
  readonly items?: LinkItem[]

  readonly submenuItems?: LinkItem[]

  renderBack () {
    if (this.items && this.items?.length > 1) {
      const elem = this.items[this.items.length - 2]
      return (
        <nuxt-link to={elem.location} class="breadcrumb__back">
          <ArrowSvg />
          <div class="breadcrumb__back-text">
            {elem.title}
          </div>
        </nuxt-link>
      )
    }
  }

  renderSubmenu (submenuItems: LinkItem[]) {
    return (
      <ul class="breadcrumb__submenu">
        {submenuItems?.map((e: LinkItem) => (
          <li class="breadcrumb__submenu-item">
            <nuxt-link to={e.location}>
              <span>{e.title}</span>
            </nuxt-link>
          </li>
        ))}
      </ul>
    )
  }

  render () {
    return (
      <div class="breadcrumb">
        <ul class="breadcrumb__list" itemscope itemtype="https://schema.org/BreadcrumbList">
          {this.items?.map((e: LinkItem, i: number) => (
            <li class="breadcrumb__item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
              <nuxt-link to={e.location} class="breadcrumb__link" itemprop="item">
                <span itemprop="name">{e.title}</span>
                <meta itemprop="position" content={i + 1} />
              </nuxt-link>
              {e.submenuItems && e.submenuItems.length > 0 && this.renderSubmenu(e.submenuItems)}
            </li>
          ))}
        </ul>
        {this.renderBack()}
      </div>
    )
  }
}
